import request from '@/utils/request'

export default {
  // 获取专升本专业列表
  getList(page, size, keyword) {
    return request.get('/upgrade-major/list', {
      params: { page, size, keyword }
    })
  },

  // 添加专升本专业
  add(data) {
    return request.post('/upgrade-major/add', data)
  },

  // 更新专升本专业
  update(data) {
    return request.put('/upgrade-major/update', data)
  },

  // 删除专升本专业
  delete(id) {
    return request.delete(`/upgrade-major/delete/${id}`)
  },

  // 批量删除专升本专业
  batchDelete(ids) {
    return request.post('/upgrade-major/batch-delete', ids)
  },

  // 根据学校ID获取专业列表
  getByCollege(collegeId) {
    return request.get('/upgrade-major/by-college', {
      params: { collegeId }
    })
  }
}
